const SALT = "zedxapps";

/**
 * Lightweight obfuscation for numeric IDs shown in URLs.
 * NOT a security measure — anyone can decode it in one line.
 * Server-side endpoints must still authorize access to the resolved ID.
 */

export const encodeRouteId = (id: number | string): string => {
	return btoa(`${SALT}_${id}_${SALT}`);
};

export const decodeRouteId = (encoded: string | undefined): number | null => {
	if (!encoded) return null;

	try {
		const parts = atob(encoded).split("_");
		const decoded = Number(parts[1]);
		return Number.isNaN(decoded) ? null : decoded;
	} catch {
		// atob throws on invalid base64 (e.g. malformed/tampered URL param)
		return null;
	}
};